var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout_redesign--header-wrapper"},[_c('p',{staticClass:"checkout_redesign--abHeader"},[_vm._v(_vm._s(_vm.headerParams.title)+":")]),_vm._v(" "),_c('p',{staticClass:"checkout_redesign--header"},[_vm._v(_vm._s(_vm.headerParams.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }